// 搜尋頁面 - 無搜尋結果
import Image from 'next/image';
import { useTranslation } from 'react-i18next';

const SearchEmptyResult = () => {
    const { t } = useTranslation();

    return (
        <div
            className="flex-grow text-center space-y-[10px] bg-jblack rounded-[12px] flex flex-col justify-center
            py-[60px] usm:py-[30px]"
        >
            <div className="img-box w-full max-w-[354px] aspect-[354/243] mx-auto right-[10px]">
                <Image
                    width={354}
                    height={243}
                    src="/images/icon/icon_search_empty.svg"
                    alt="icon"
                />
            </div>

            <p className="text-h3 text-white">{t('EMPTY')}</p>
            <pre className="text-bd1m text-black3">{t('NO_RESULT')}</pre>
        </div>
    );
};

export default SearchEmptyResult;
